import {
    Box,
    Paper,
    Typography,
} from "@mui/material";

import CheckCircleOutlineIcon
    from "@mui/icons-material/CheckCircleOutline";


const LABEL = Object.freeze({
    title:
        "Einrichtung abgeschlossen",

    message:
        "Sie können ab sofort Zahlungen über NEXUS empfangen.",
});


const STYLE = Object.freeze({
    root: {
        width: "100%",
        boxSizing: "border-box",
        marginTop: "50px",
        overflow: "hidden",
    },

    content: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",

        px: {
            xs: 3,
            sm: 4,
            md: 5,
        },

        py: {
            xs: 6,
            md: 8,
        },
    },

    icon: {
        fontSize: {
            xs: 72,
            md: 88,
        },

        color: "success.main",
        mb: 2,
    },

    title: {
        fontWeight: 500,
        mb: 1,
    },

    message: {
        color: "text.secondary",
        maxWidth: 600,
        lineHeight: 1.7,
    },
});


export default function PaymentOnboardingCompleted() {
    return (
        <Paper
            component="main"
            sx={STYLE.root}
        >
            <Box sx={STYLE.content}>
                <CheckCircleOutlineIcon
                    sx={STYLE.icon}
                />

                <Typography
                    variant="h4"
                    component="h1"
                    sx={STYLE.title}
                >
                    {LABEL.title}
                </Typography>

                <Typography
                    variant="body1"
                    component="p"
                    sx={STYLE.message}
                >
                    {LABEL.message}
                </Typography>
            </Box>
        </Paper>
    );
}